<template>
    <div class="search-screen flex align-items">
        <div class="search-screen-left">
            <a-form layout="inline">

                <!--学习记录-->
                <template v-if="scenario == 'studyList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="学员姓名" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--班级课程-->
                <template v-if="scenario == 'clessonList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="课程名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--学员-->
                <template v-if="scenario == 'cstudentList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="学员名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--班级-->
                <template v-if="scenario == 'classList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="班级名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.type">
                            <a-select-option value="">类型</a-select-option>
                            <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.mid">
                            <a-select-option value="">就业专员</a-select-option>
                            <a-select-option v-for="(item, key) in config.manager" :key="key" :value="item[0]">{{
                                    item[1]
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--学生-->
                <template v-if="scenario == 'studentList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="学生名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--学院-->
                <template v-if="scenario == 'collegeList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="学院名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--学校-->
                <template v-if="scenario == 'schoolList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="学校名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--专业-->
                <template v-if="scenario == 'majorList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="专业名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.pid">
                            <a-select-option value="">父级专业</a-select-option>
                            <a-select-option v-for="(item, key) in config.major" :key="key" :value="item.maid">{{
                                    item.name
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--教室-->
                <template v-if="scenario == 'classroomList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="教室名" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--老师-->
                <template v-if="scenario == 'teacherList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="老师姓名" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.type">
                            <a-select-option value="">类型</a-select-option>
                            <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--课程模块-->
                <template v-if="scenario == 'lchapterList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="课程名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.type">
                            <a-select-option value="">类型</a-select-option>
                            <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--课程模块-->
                <template v-if="scenario == 'lmoduleList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="课程模块" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--课程库-->
                <template v-if="scenario == 'lessonList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="课程库" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--账户-->
                <template v-if="scenario == 'userList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="账户名或手机" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.type">
                            <a-select-option value="">账户类型</a-select-option>
                            <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--简历拜访记录-->
                <template v-if="scenario == 'resumeVisitList'">

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.mid">
                            <a-select-option value="">客户经理</a-select-option>
                            <a-select-option v-for="(item, key) in config.manager" :key="key" :value="item[0]">{{
                                    item[1]
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.vistatus">
                            <a-select-option value="">拜访状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.vistatus" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--标签-->
                <template v-if="scenario == 'flagList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="标签名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--简历-->
                <template v-if="scenario == 'resumeList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="姓名或手机" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.mid">
                            <a-select-option value="">客户经理</a-select-option>
                            <a-select-option v-for="(item, key) in config.manager" :key="key" :value="item[0]">{{
                                    item[1]
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.vistatus">
                            <a-select-option value="">拜访状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.vistatus" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.from">
                            <a-select-option value="">简历来源</a-select-option>
                            <a-select-option v-for="(item, key) in config.from" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--货物库存-->
                <template v-if="scenario == 'psiLogList'">
                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.type">
                            <a-select-option value="">类型</a-select-option>
                            <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--货物-->
                <template v-if="scenario == 'psiList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="货物名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--工资-->
                <template v-if="scenario == 'sabillList'">

                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="企业名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>
                <!--工资列表-->
                <template v-if="scenario == 'salaryList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="姓名|手机|身份证后6位" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-month-picker placeholder="账单月" v-model="postData.month"/>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.show">
                            <a-select-option value="">员工可查</a-select-option>
                            <a-select-option v-for="(item, key) in config.show" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--员工管理-->
                <template v-if="scenario == 'employeeList'">
                    <a-form-item>
                        <a-input style="width: 166px;" type="text" placeholder="姓名|手机|身份证后6位" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-input style="width: 120px;" type="text" placeholder="供应商" v-model="postData.supname"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.mid">
                            <a-select-option value="">招聘经理</a-select-option>
                            <a-select-option v-for="(item, key) in config.manager" :key="key" :value="item[0]">{{
                                    item[1]
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.type">
                            <a-select-option value="">职位类型</a-select-option>
                            <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.departure">
                            <a-select-option value="">离职状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.departure" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.sex">
                            <a-select-option value="">性别</a-select-option>
                            <a-select-option v-for="(item, key) in config.sex" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>
                <!--员工合同-->
                <template v-if="scenario == 'employeeContract'">
                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--职位管理-->
                <template v-if="scenario == 'jobList'">
                    <a-form-item>
                        <a-input type="text" placeholder="职位名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-input type="text" placeholder="企业名称" v-model="postData.ename"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.type">
                            <a-select-option value="">职位类型</a-select-option>
                            <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--企业管理-->
                <template v-if="scenario == 'enterpriseList'">
                    <a-form-item>
                        <a-input type="text" placeholder="企业名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 100px;" v-model="postData.service">
                            <a-select-option value="">服务状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.service" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>
                <!--企业合同-->
                <template v-if="scenario == 'enterpriseContract'">
                    <a-form-item>
                        <a-select style="width: 80px;" v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <!--主账户管理-->
                <template v-if="scenario == 'AccountManage'">
                    <a-form-item>
                        <a-input type="text" placeholder="企业名称" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="postData.viptype">
                            <a-select-option value="">会员类型</a-select-option>
                            <a-select-option v-for="(item, key) in config.viptype" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-date-picker style="width:130px" placeholder="会员到期日期" v-model="postData.date"/>
                    </a-form-item>
                </template>

                <!--用户管理-->
                <template v-if="scenario == 'accountList'">
                    <a-form-item>
                        <a-input type="text" placeholder="姓名关键词" v-model="postData.keyword"></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="postData.status">
                            <a-select-option value="">状态</a-select-option>
                            <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">{{
                                    item
                                }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="postData.roleid">
                            <a-select-option value="">部门名称</a-select-option>
                            <a-select-option v-for="(item, key) in config.roleid" :key="item.roleid"
                                             :value="item.roleid">{{ item.rolename }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </template>

                <a-form-item v-if="showSearch">
                    <a-button-group>
                        <a-button @click="clear">重置</a-button>
                        <a-button type="primary" @click="search">搜索</a-button>
                    </a-button-group>
                </a-form-item>
            </a-form>
        </div>
        <div class="search-screen-right">
            <a href="javascript:void(0);" v-if="showExport" @click="exportRes">
                <icon-font type="icontool_export"/>
                导出结果
            </a>
            <a href="javascript:void(0);" @click="showModal()" v-if="showSetCondition">
                <icon-font type="icontool_set"/>
                显示设置
            </a>
        </div>

        <!-- 弹框  -->
        <a-modal
            okText="确定"
            cancelText="取消"
            v-model="visible"
            @ok="handleOk"
            @cancel="closeSetModal"
            :closable=false
            class="modal-initialize"
            width="700px"
            v-if="showSetCondition"
        >
            <template slot="title">
                <div class="modal-title flex">
                    <h4>显示设置</h4>
                    <icon-font type="iconclose" @click="closeSetModal"/>
                </div>
            </template>
            <div class="display-modal-body">
                <div class="choose-pageno hro-modal-title">
                    <h4>每页显示数量</h4>
                    <div class="pageno-btn-list">
                        <a-button
                            type="primary"
                            size="small"
                            v-for="(item, key) in setCondition.pagesize"
                            :key="key"
                            :class="{'grey-btn': parseInt(item) != modalData.pagesize}"
                            @click="modalData.pagesize = parseInt(item)">
                            {{ item }}
                        </a-button>
                    </div>
                </div>
                <div class="choose-table-title hro-modal-title">
                    <h4>选择列表显示的标题信息</h4>
                    <div class="title-groups">
                        <a-checkbox-group @change="onChange" :value="modalData.showfield">
                            <a-row>
                                <a-col
                                    :span="6"
                                    v-for="(item, key) in setCondition.field"
                                    :key="key"
                                >
                                    <a-checkbox :value="item.key" :disabled="item.default == 1">{{
                                            item.text
                                        }}
                                    </a-checkbox>
                                </a-col>
                            </a-row>
                        </a-checkbox-group>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import moment from 'moment';
import {Icon} from 'ant-design-vue';

const IconFont = Icon.createFromIconfontCN({
    scriptUrl: process.env.VUE_APP_ICONURL,
});

export default {
    components: {
        IconFont,
    },
    props: {
        // 条件
        condition: {
            type: Object,
            default: null
        },
        // 选中数据
        checkData: {
            type: Object,
            default: null,
        },
        // 显示设置条件
        setCondition: {
            type: Object,
            default: null
        },
        // 配置
        config: {
            type: Object,
            default: null
        },
        // 场景
        scenario: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            formatYear: 'YYYY',
            modeYear: 'year',
            visible: false,
            showModalSearch: false,
            formItemLayout: {
                labelCol: {
                    span: 4
                },
                wrapperCol: {
                    span: 20
                },
            },
            postData: {},
            modalData: {
                pagesize: 0,
                showfield: [],
            },
            dateFormat: 'YYYY-MM-DD',
        }
    },
    computed: {
        // 导出
        showExport() {
            let scenarioArr = ['enterpriseList'];
            if (this.inArray(this.scenario, scenarioArr) > -1) {
                return true;
            }

            return false;
        },
        // 显示设置
        showSetCondition() {
            return true;
            /*
            let scenarioArr = ['myProjectList', 'projectList', 'visitList', 'assignList', 'myClassList', 'classList'];
            if(this.inArray(this.scenario, scenarioArr) > -1) {
                return true;
            } else {
                return false;
            }
            */
        },
        // 搜索按钮
        showSearch() {
            let scenarioArr = ['payList', 'billList'];
            if (this.inArray(this.scenario, scenarioArr) > -1) {
                return false;
            }

            return true;
        },
    },
    watch: {
        checkData() {
            // 筛选数据
            this.initConditionData();
        },
        setCondition() {
            this.initModalData();
        },
    },
    created() {
        this.initConditionData();
    },
    methods: {
        // 导出结果
        exportRes() {
            this.$emit('exportRes');
        },
        // 显示设置
        showModal() {
            this.visible = true;
        },
        handleOk() {
            this.visible = false;
            this.$emit('setOption', this.modalData);
        },
        closeSetModal() {
            this.visible = false;
            this.initModalData();
        },
        // 开始日期禁用
        disabledStartDate(startValue) {
            const endValue = this.postData.eupdatetime;
            if (!startValue || !endValue) {
                return false;
            }
            return startValue.valueOf() > endValue.valueOf();
        },
        // 结束日期禁用
        disabledEndDate(endValue) {
            const startValue = this.postData.supdatetime;
            if (!endValue || !startValue) {
                return false;
            }
            return startValue.valueOf() >= endValue.valueOf();
        },
        // 初始化
        initModalData() {
            // 弹框数据
            let field = [];
            for (let i in this.setCondition.field) {
                if (this.setCondition.field[i].default == 1) {
                    field.push(this.setCondition.field[i].key);
                }
            }

            this.modalData = {
                pagesize: this.checkData.pagesize,
                showfield: this.checkData.showfield && this.checkData.showfield.length > 0 ? this.checkData.showfield : field,
            };
        },
        onChange(checkedValues) {
            this.modalData.showfield = checkedValues;
        },
        // 重置筛选
        clear() {
            this.$emit('clear');
        },
        // 筛选
        search() {
            let params = {};
            for (var i in this.postData) {
                params[i] = this.postData[i];
            }

            // 处理时间等需要定制的搜索项
            switch (this.scenario) {
                case 'kaoqinList':
                    params.sdate = params.sdate ? params.sdate.format('YYYY-MM-DD') : '';
                    params.edate = params.edate ? params.edate.format('YYYY-MM-DD') : '';
                    break;
                case 'salaryList':
                    params.month = params.month ? params.month.format('YYYY-MM') : '';
                    break;
                default:
                    break;
            }

            this.$emit('search', params);
        },
        initConditionData() {
            let params = {};
            for (var i in this.checkData) {
                params[i] = this.checkData[i];
            }

            // 处理时间等需要定制的搜索项
            switch (this.scenario) {
                case 'kaoqinList':
                    params.sdate = params.sdate ? moment(params.sdate) : null;
                    params.edate = params.edate ? moment(params.edate) : null;
                    break;
                case 'salaryList':
                    params.month = params.month ? moment(params.month) : null;
                    break;
                default:
                    break;
            }

            this.postData = params;
            this.postData.page = 1;
        },
        changeModal(e, type) {
            switch (type) {
                case 1:
                    this.showModalSearch = e;
                    break;
                default:
                    break;
            }
        },
    },
}
</script>

<style lang="less">
.search-screen {
    justify-content: space-between;
    padding-bottom: 30px;

    .search-screen-right {
        a {
            i {
                margin-right: 8px;
            }
        }
    }
}

@media screen and (max-width: 1350px) {
    .search-screen-left {
        .ant-input {
            width: 120px;
        }
    }
}
</style>
